import React from "react";
import { gql, useMutation } from "@apollo/client";
import { Form } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import { Price } from "@syos-music/common";

import { Box, CircularProgress, InputAdornment, Stack } from "@mui/material";
import { TruckDelivery as ShippingIcon } from "mdi-material-ui";

import ShippingMethodSelectField from "components/form/ShippingMethodSelectField";

import OrderSidebar from "../index";

export default function Shipping({ order }) {
  const [mutate] = useMutation(
    React.useMemo(
      () =>
        gql`
          mutation ($orderId: ID!, $shippingMethodId: ID) {
            UpdateOrderAdmin(
              orderId: $orderId
              shippingMethodId: $shippingMethodId
            ) {
              order {
                id
                ...OrderSidebar_order
              }
            }
          }

          ${OrderSidebar.fragments.order}
        `,

      []
    )
  );

  const handleSubmit = React.useCallback(
    ({ shippingMethod }) =>
      mutate({
        variables: {
          orderId: order.id,
          shippingMethodId: shippingMethod?.id,
        },
      })
        .then(() => {})
        .catch(() => true),
    [mutate, order.id]
  );

  return (
    <Stack spacing={1}>
      {!order.paymentId && (
        <Form
          onSubmit={handleSubmit}
          initialValues={{ shippingMethod: order.shippingMethod }}
        >
          {({ form, handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit}>
              <ShippingMethodSelectField
                name="shippingMethod"
                disabled={submitting}
                priceCountryId={order.shippingAddress?.countryId}
                priceTaxRate={order.taxRate}
                cartTotal={order.cartTotal}
                SelectProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {submitting ? (
                        <CircularProgress size={27} />
                      ) : (
                        <ShippingIcon />
                      )}
                    </InputAdornment>
                  ),
                }}
              />

              <OnChange name="shippingMethod">
                {async (shippingMethod) => {
                  if (!shippingMethod) return;
                  if (shippingMethod.id === order.shippingMethod?.id) return;

                  form.submit();
                }}
              </OnChange>
            </form>
          )}
        </Form>
      )}

      <Stack spacing={1} direction="row" alignItems="center">
        <Box sx={{ flexGrow: 1 }}>
          Frais de livraison
          {order.paymentId && (
            <strong>&nbsp;{order.shippingMethod.label.fr}</strong>
          )}
          &nbsp;:&nbsp;
        </Box>

        <strong>
          <Price {...order.shippingFee} taxRate={order.taxRate} />
        </strong>
      </Stack>
    </Stack>
  );
}

Shipping.fragments = {
  order: gql`
    fragment OrderSidebar_Cart_Shipping_order on Order {
      id
      paymentId

      cartTotal {
        currency
        value
      }
      shippingFee {
        currency
        value
      }
      taxRate

      shippingMethod {
        id
        label {
          fr
        }
      }

      shippingAddress {
        countryId
      }
    }
  `,
};
